import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Phone } from "lucide-react";
import { PHONE_TEL } from "../../lib/site";

export const ServiceCard = ({ service, index }) => {
  const Icon = service.icon;
  return (
    <motion.article
      data-testid={`service-card-${service.id}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
      className="group relative flex h-full flex-col overflow-hidden border border-[#D4AF37]/15 bg-[#0E081D]/80 transition-[border-color,background-color] duration-500 hover:border-[#D4AF37]/50 hover:bg-[#150C28]"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img src={service.image} alt={`${service.title} in Calgary`} loading="lazy" data-testid={`service-image-${service.id}`}
          className="h-full w-full object-cover brightness-125 saturate-125 transition-transform duration-1000 ease-out group-hover:scale-105" />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0E081D] to-transparent" />
        <span className="font-cinzel absolute left-5 top-5 bg-[#07040D]/70 px-2.5 py-1 text-xs tracking-[0.25em] text-[#F3E5AB] backdrop-blur">{String(index + 1).padStart(2, "0")}</span>
        <span className="absolute bottom-4 right-5 flex h-12 w-12 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#07040D]/70 text-[#D4AF37] backdrop-blur transition-[background-color,color] duration-500 group-hover:bg-[#D4AF37] group-hover:text-[#07040D]">
          <Icon className="h-5 w-5" strokeWidth={1.4} />
        </span>
      </div>
      <div className="flex flex-1 flex-col p-7 pt-4 sm:p-8 sm:pt-5">
        <h3 className="font-display text-3xl leading-tight text-white">{service.title}</h3>
        <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-300 sm:text-[15px]">{service.text}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to={`/book?service=${service.id}`} data-testid={`service-book-now-${service.id}`}
            className="inline-flex h-11 items-center gap-2 rounded-full bg-[#D4AF37] px-5 text-sm font-medium text-[#07040D] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#F3E5AB]">
            Book Now <ArrowUpRight className="h-4 w-4" />
          </Link>
          <a href={PHONE_TEL} data-testid={`service-call-${service.id}`} aria-label={`Call about ${service.title}`}
            className="inline-flex h-11 items-center gap-2 rounded-full border border-[#D4AF37]/40 px-5 text-sm text-slate-100 transition-[border-color,background-color] duration-300 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10">
            <Phone className="h-4 w-4 text-[#D4AF37]" /> Call
          </a>
        </div>
      </div>
    </motion.article>
  );
};
